/* eslint-disable no-nested-ternary */
/* eslint-disable no-mixed-spaces-and-tabs */
import React from 'react';

import Button from '@material-ui/core/Button';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Grid, Container } from '@material-ui/core';
import Icons from 'consts/icons';
import UserSessionDataHandler from 'auth/UserSessionsDataHandler';
import CustomizedTable from 'components/common/components/tablev2/CustomizedTable';
import PermissionsGate from 'components/common/PermissionGate';
import { SCOPES } from 'consts/permission-maps';
import { userStyles } from 'consts/styles/User';
import ButtonsUseStyles from 'consts/styles/Buttons';
import Tooltip from '@material-ui/core/Tooltip';
import { formStyles } from 'consts/styles/Form';
import DisplayActivations from './ActivationsDisplay';

const DisplayZoneDetails = props => {
  const { zoneToDisplay, zoom, setZoneToEdit, deletePrivateZone } = props;

  const subtitles = useSelector(state => state.language).zonesDetails;
  const heightUnit = useSelector(state => state.heightUnit);

  const userSettingObject = UserSessionDataHandler.getUserSettingsObject();
  const lang =
    userSettingObject &&
    userSettingObject[UserSessionDataHandler.defaultLanguage]
      ? userSettingObject[UserSessionDataHandler.defaultLanguage]
      : 'en';

  const classesUser = userStyles();
  const classesButtons = ButtonsUseStyles();
  const formClasses = formStyles();

  return (
    <>
      {zoneToDisplay ? (
        <Grid container className={`${classesUser.User}__settings`}>
          <div className={`${classesUser.User}__settings__content__spacer`} />
          <div
            className={`${formClasses.Form}--flex ${formClasses.Form}--flex--direction ${formClasses.Form}--flex--between`}
          >
            <Container>
              <Grid
                container
                spacing={1}
                className={`${formClasses.Form}--flex ${formClasses.Form}--flex--between`}
              >
                <Grid item xs={12}>
                  <div className={`${formClasses.Form}__label`}>
                    {`${subtitles.uid_}: `}
                    <span
                      className={`${formClasses.Form}__text-field--small-font ${formClasses.Form}__text-field`}
                    >
                      {zoneToDisplay.uid}
                    </span>
                  </div>
                </Grid>
              </Grid>
            </Container>
            <Container>
              <Grid
                container
                spacing={1}
                className={`${formClasses.Form}--flex ${formClasses.Form}--flex--between`}
              >
                <Grid item xs={9}>
                  <div className={`${formClasses.Form}__label`}>
                    {subtitles.name_}
                  </div>
                  <div className={`${formClasses.Form}__text-field`}>
                    {zoneToDisplay.uid.substring(0, 8)}
                  </div>
                </Grid>
                <Grid
                  item
                  xs={3}
                  align="right"
                  className={`${formClasses.Form}--flex ${
                    setZoneToEdit
                      ? `${formClasses.Form}--flex--between`
                      : `${formClasses.Form}--flex--flex-end`
                  }`}
                >
                  {setZoneToEdit ? (
                    <PermissionsGate scopes={[SCOPES.canChangeZone]}>
                      <Tooltip title={subtitles.edit_} placement="left">
                        <Button
                          onClick={() => setZoneToEdit(zoneToDisplay)}
                          fullWidth
                          className={`${classesButtons.Buttons} ${classesButtons.Buttons}--color ${classesButtons.ButtonsCircle}--mid ${classesButtons.ButtonsCircle}`}
                        >
                          <Icons.Actions.Edit2 />
                        </Button>
                      </Tooltip>
                    </PermissionsGate>
                  ) : null}
                  <Tooltip title={subtitles.zoom_} placement="right">
                    <Button
                      type="button"
                      fullWidth
                      onClick={() => zoom(zoneToDisplay.geojson)}
                      className={`${classesButtons.Buttons} ${classesButtons.Buttons}--color ${classesButtons.ButtonsCircle}--mid ${classesButtons.ButtonsCircle}`}
                    >
                      <Icons.Zoom.ZoomInOnMap />
                    </Button>
                  </Tooltip>
                </Grid>
              </Grid>
            </Container>
            <Container>
              <Grid
                container
                spacing={1}
                className={`${formClasses.Form}--flex ${formClasses.Form}--flex--between ${formClasses.Form}--height--dashboard-min-height`}
              >
                <Grid item xs={6}>
                  <span className={`${formClasses.Form}__label`}>
                    {subtitles.name_}
                  </span>
                  <br />
                  <span
                    className={`${formClasses.Form}__text-field--small-font ${formClasses.Form}__text-field`}
                  >
                    {zoneToDisplay.name || zoneToDisplay.othername}
                  </span>
                </Grid>
                <Grid item xs={6}>
                  <span className={`${formClasses.Form}__label`}>
                    {subtitles.type_}
                  </span>
                  <br />
                  <span
                    className={`${formClasses.Form}__text-field--small-font ${formClasses.Form}__text-field`}
                  >
                    {zoneToDisplay.type}
                  </span>
                </Grid>

                <Grid item xs={6}>
                  <span className={`${formClasses.Form}__label`}>
                    {subtitles.heightMin_}
                  </span>
                  <br />
                  <span
                    className={`${formClasses.Form}__text-field--small-font ${formClasses.Form}__text-field`}
                  >
                    {`${heightUnit === 'ft.' ? zoneToDisplay.amsl_min : zoneToDisplay.agl_min} ${heightUnit}`}
                  </span>
                </Grid>
                <Grid item xs={6}>
                  <span className={`${formClasses.Form}__label`}>
                    {subtitles.heightMax_}
                  </span>
                  <br />
                  <span
                    className={`${formClasses.Form}__text-field--small-font ${formClasses.Form}__text-field`}
                  >
                    {`${heightUnit === 'ft.' ? zoneToDisplay.amsl_max : zoneToDisplay.agl_max} ${heightUnit}`}
                  </span>
                </Grid>

                <Grid item xs={12}>
                  <span className={`${formClasses.Form}__label`}>
                    {subtitles.description_}
                  </span>
                  <br />
                  <span
                    className={`${formClasses.Form}__text-field--small-font ${formClasses.Form}__text-field`}
                  >
                    {zoneToDisplay.description
                      ? zoneToDisplay.description[lang]
                      : '-'}
                  </span>
                </Grid>

                <Grid item xs={6}>
                  <span className={`${formClasses.Form}__label`}>
                    {subtitles.visibilityType_}
                  </span>
                  <br />
                  <span
                    className={`${formClasses.Form}__text-field--small-font ${formClasses.Form}__text-field`}
                  >
                    {zoneToDisplay.visibility ? (
                      <>
                        <Icons.Filters.ButtonPrivate /> {subtitles.private_}
                      </>
                    ) : (
                      <>
                        <Icons.Filters.ButtonPublic /> {subtitles.public_}
                      </>
                    )}
                  </span>
                </Grid>
                <Grid item xs={6}>
                  <span className={`${formClasses.Form}__label`}>
                    {subtitles.activityType_}
                  </span>
                  <br />
                  <span
                    className={`${formClasses.Form}__text-field--small-font ${formClasses.Form}__text-field`}
                  >
                    {zoneToDisplay.active ? (
                      <>
                        <Icons.Filters.ActionSuccess />
                        {subtitles.activeYes_}
                      </>
                    ) : (
                      <>
                        <Icons.Filters.ActionFail />
                        {subtitles.activeNo_}
                      </>
                    )}
                  </span>
                </Grid>

                <Grid item xs={6}>
                  <span className={`${formClasses.Form}__label`}>
                    {subtitles.contact_}
                  </span>
                  <br />
                  <span
                    className={`${formClasses.Form}__text-field--small-font ${formClasses.Form}__text-field`}
                  >
                    {zoneToDisplay.contact || '-'}
                  </span>
                </Grid>
                {zoneToDisplay.visibility === 'private' ? (
                  <>
                    <Grid item xs={12} className={`${formClasses.Form}__label`}>
                      <DisplayActivations
                        activations={zoneToDisplay.activations}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      {zoneToDisplay.identifications?.length ? (
                        <CustomizedTable
                          headers={[subtitles.uid_]}
                          data={zoneToDisplay.identifications.map(
                            identification => ({
                              id: identification?.drones?.id,
                            })
                          )}
                          smallTable
                        />
                      ) : (
                        <span className={`${formClasses.Form}__label`}>
                          {subtitles.identifications.noItems_ || '-'}
                        </span>
                      )}
                    </Grid>
                  </>
                ) : (
                  <div
                    className={`${classesUser.User}__settings__content__spacer`}
                  />
                )}
                {deletePrivateZone ? (
                  <Grid item xs={12}>
                    <PermissionsGate scopes={[SCOPES.canDeleteZone]}>
                      <Button
                        onClick={() => deletePrivateZone(zoneToDisplay.name)}
                        startIcon={<Icons.Actions.Clear />}
                        className={`${formClasses.Form}--width ${classesButtons.Buttons} ${classesButtons.Buttons}--color ${classesButtons.ButtonsRectangle} ${classesButtons.Buttons}--reject`}
                      >
                        {subtitles.remove_}
                      </Button>
                    </PermissionsGate>
                  </Grid>
                ) : null}
              </Grid>
            </Container>
          </div>
        </Grid>
      ) : null}
    </>
  );
};

DisplayZoneDetails.propTypes = {
  zoneToDisplay: PropTypes.object.isRequired,
  zoom: PropTypes.func.isRequired,
  setZoneToEdit: PropTypes.func,
  deletePrivateZone: PropTypes.func,
};

export default DisplayZoneDetails;
